/*
 * File: zh-TW.ts
 * File Created: 2023-11-27 03:14:02
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-03-12 10:11:06
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { RegisterLanguage, ILang } from "@root/core/i18n";

@RegisterLanguage("zh-TW", "正體中文")
export default class LangObject {
    /// copyright
    w_Copyright = "HCU Tech 2025 © All rights reserved.";

    /// Login
    w_RememberMe = "記住我";
    w_ForgetPassword = "忘記密碼";

    /// Menu
    w_UserManagement = "使用者管理";
    w_UserList = "使用者";
    w_MenuLoginLog = "登入紀錄";
    w_MenuOrgAndMember = "組織與成員";
    w_MenuOrgList = "組織";
    w_MenuMembership = "成員關係";
    w_MenuBilling = "金流與帳務";
    w_MenuFinanceCredits = "財務與點數";
    w_MenuWallet = "錢包";
    w_MenuLedger = "交易紀錄";
    w_MenuPromoAndRedeem = "優惠與兌換";
    w_MenuPromoCode = "優惠代碼";
    w_MenuRedeemCode = "兌換代碼";
    w_MenuRedemption = "兌換紀錄";
    w_MenuTranslation = "檔案翻譯";
    w_MenuTranslateTask = "翻譯任務";
    w_MenuTranslateTaskContent = "任務詳情";

    /// Maintenance
    w_MaintenanceStatus = "系統維護中";
    w_MaintenanceTitle = "系統維護進行中";
    w_MaintenanceDesc =
        "為了提供更優質的服務，QUAFF AI 目前正在進行系統升級維護。維護期間各項服務將暫時無法使用。造成您的不便敬請見諒，感謝您的耐心等候。";
    w_MaintenanceEtaLabel = "預計恢復時間";
    w_MaintenanceRefresh = "重新整理";
    w_MaintenanceSupport = "需要協助？請聯絡客服。";
    w_MaintenanceTBD = "待定";
    w_MaintenanceEmailSubject = "QUAFF AI 維護協助";

    /// Invoice
    w_InvoiceInfo = "發票資訊";
    w_InvoiceTypePersonal = "個人";
    w_InvoiceTypeCompany = "公司";
    w_InvoiceTypeOverseas = "非台灣用戶";
    w_InvoiceEmail = "電子郵件";
    w_InvoiceCarrier = "手機載具";
    w_InvoiceCompanyName = "公司抬頭";
    w_InvoiceTaxId = "統一編號";
    w_InvoiceEmailRequired = "請填寫電子郵件";
    w_InvoiceTypeRequired = "請選擇發票類型";
    w_InvoiceCompanyNameRequired = "請填寫公司抬頭";
    w_InvoiceTaxIdInvalid = "統一編號需為 8 碼數字";
    w_InvoiceTaxIdInvalidChecksum = "統一編號不合規範";
    w_MenuTranslateError = "失敗任務管理";
    w_MenuAIServices = "AI 服務";

    /// Title
    w_TitleRelatedAccount = "關聯帳號";

    /// Header
    w_HeaderRelation = "關聯";
    w_HeaderAdditionalCondition = "額外條件";

    /// View
    // User
    w_UserPageDescription = "管理使用者、權限與狀態。";
    w_UserCreateNew = "建立新使用者";
    w_UserRoleAdmin = "管理員";
    w_UserRoleBillingAdmin = "帳務管理員";
    w_UserRoleUser = "一般使用者";
    w_UserProfile = "個人資料";
    w_UserName = "使用者名稱";
    w_UserInfo = "使用者資訊";
    w_UserAccounts = "關聯帳號";
    w_UserResetPassword = "重設密碼";
    w_UserRelationSummary = "關聯統計";
    w_UserLinkNewAccount = "連結新帳號";
    w_UserLinkedAccounts = "已連結帳號";
    w_UserUnlinkAccount = "解除連結";
    w_UserLinkedOrganizations = "組織";
    w_UserOwnedOrganizations = "擁有的組織";
    w_UserCreateOrganization = "建立組織";
    w_UserBelongOrganizations = "所屬的組織";
    w_UserMemberships = "成員資格";
    w_UserMembershipsNote = "此使用者加入但非擁有者的組織。";
    w_UserOrganizations = "關聯組織";

    /// Payment Success
    w_PaymentSuccess_TitleSuccess = "付款成功！";
    w_PaymentSuccess_TitleFailed = "付款失敗";
    w_PaymentSuccess_DescSuccess =
        "感謝您的儲值，系統已確認收到您的款項，並已將點數加值至您的組織錢包中。";
    w_PaymentSuccess_DescFailed = "此次付款未完成，若已扣款請聯絡客服並提供交易編號。";
    w_PaymentSuccess_LabelMerchantTradeNo = "交易編號";
    w_PaymentSuccess_LabelTradeNo = "金流單號";
    w_PaymentSuccess_LabelPaymentType = "付款方式";
    w_PaymentSuccess_LabelPaymentDate = "付款時間";
    w_PaymentSuccess_LabelAmount = "入帳點數";
    w_PaymentSuccess_LabelPaidAmount = "付款金額 (TWD)";
    w_PaymentSuccess_LabelDiscount = "折扣金額 (TWD)";
    w_PaymentSuccess_LabelRtnMsg = "交易訊息";
    w_PaymentSuccess_PaymentTypeDefault = "信用卡 (ECPay)";
    w_PaymentSuccess_Close = "關閉此視窗";
    w_PaymentSuccess_AutoClose = "本視窗將在 {0} 秒後自動關閉...";
    w_PaymentSuccess_CloseManual = "請手動關閉此分頁";
    w_PaymentSuccess_CloseManualDesc =
        "安全限制：瀏覽器不允許自動關閉，請直接關閉此分頁。";

    /// Topup Discount
    w_TranslationJobTopupDiscountEmpty = "請輸入折扣碼。";
    w_TranslationJobTopupDiscountNotFound = "折扣碼不存在。";
    w_TranslationJobTopupDiscountDisabled = "折扣碼已停用。";
    w_TranslationJobTopupDiscountNotStarted = "折扣碼尚未開始。";
    w_TranslationJobTopupDiscountExpired = "折扣碼已過期。";
    w_TranslationJobTopupDiscountMaxUses = "折扣碼已達使用上限。";
    w_TranslationJobTopupDiscountNotDiscount = "此折扣碼不可用於折扣。";
    w_TranslationJobTopupDiscountMinSpend = "未達最低消費門檻（{0}）。";
    w_TranslationJobTopupDiscountOrgLimit = "此組織已達折扣使用上限。";
    w_TranslationJobTopupDiscountInvalid = "折扣碼無效。";
    w_TranslationJobTopupDiscountApplied = "折扣碼已套用";

    // Account
    w_AccountLocalName = "{0} (本機帳號)";
    w_AccountLdapName = "{0} (LDAP 帳號)";
    w_AccountGoogleName = "{0} (Google 帳號)";
    w_AccountFieldProvider = "帳號來源";
    w_AccountFieldProviderId = "帳號 ID / Email";
    w_AccountProviderCredentials = "本機帳號";
    w_AccountProviderLdap = "LDAP 帳號";
    w_AccountProviderGoogle = "Google 帳號";
    w_AccountLinkedAt = "連結時間";

    // Organization
    w_OrganizationGeneralName = "組織名稱";
    w_OrganizationRoleOwner = "擁有者";
    w_OrganizationPersonalName = "{0} 的個人空間";
    w_OrganizationOrgName = "{0} 的組織";
    w_OrganizationTypePersonal = "個人";
    w_OrganizationTypeOrg = "組織";
    w_OrganizationOwner = "組織擁有者";
    w_OrganizationMembers = "關聯成員";
    w_OrganizationBelongTo = "屬於組織";

    // Membership
    w_MembershipUser = "成員";
    w_MembershipPersonalName = "「{w_OrganizationPersonalName('{0}')}」 的成員資格";
    w_MembershipOrgName = "「{0}」 的成員資格";
    w_MembershipCustomName = "「{0}」 的成員資格";
    w_MembershipRoleAdmin = "管理員";
    w_MembershipRoleMember = "成員";

    // Wallet
    w_WalletPersonalName = "「{0}」的個人錢包";
    w_WalletOrgName = "「{0}」的組織錢包";
    w_WalletBalance = "餘額";
    w_WalletLedgerCount = "帳目總數";

    // Ledger
    w_LedgerDescription = "追蹤儲值、退款與使用的帳目紀錄。";
    w_LedgerName = "交易項目";
    w_LedgerNameId = "交易項目 / ID";
    w_LedgerReason = "原因";
    w_LedgerSource = "類型";
    w_LedgerDelta = "點數";
    w_LedgerId = "ID";
    w_LedgerFilterAll = "全部類型";
    w_LedgerExportCsv = "匯出 CSV";
    w_LedgerSourceDeposit = "儲值";
    w_LedgerSourcePromoCredit = "優惠代碼";
    w_LedgerSourceUsageDebit = "使用扣點";
    w_LedgerSourceRefund = "系統退款";
    w_LedgerSourceInitialCredit = "初始贈送";
    w_LedgerReasonInitialCredit = "初始贈送";
    w_LedgerReasonPayuniTopup = "線上儲值";
    w_LedgerReasonPromoRedeem = "兌換優惠代碼";
    w_LedgerReasonTranslationDebit = "翻譯扣款";
    w_LedgerReasonTranslationRefund = "翻譯退款";
    w_LedgerAmountRefunded = "已退款";

    // PromoCode
    w_PromoCodeDescription = "管理儲值券與折扣碼。";
    w_PromoCodeCreateNew = "新增代碼";
    w_PromoCodeSearchPlaceholder = "以名稱搜尋...";
    w_PromoCodeFilterAll = "全部類型";
    w_PromoCodeTypeValue = "類型與數值";
    w_PromoCodeLimit = "限制";
    w_PromoCodeLimitTotal = "總量限制:";
    w_PromoCodeLimitOrg = "每組織限制:";
    w_PromoCodeNote = "內部備註";
    w_PromoCodeTypeConfig = "類型設定";
    w_PromoCodeLimitsValidity = "限制與有效期間";
    w_PromoCodeKind = "兌換類別";
    w_PromoCodeName = "代碼名稱";
    w_PromoCodeNameDescription = "例：QUAFFPROMOTE_2026";
    w_PromoCodeBenefit = "優惠內容";
    w_PromoCodeEnableStatus = "啟用狀態";
    w_PromoCodeTimeRange = "兌換時間限制";
    w_PromotionCodeCredit = "儲值碼";
    w_PromotionCodeDiscount = "折扣碼";
    w_PromotionCodeDiscountType = "折扣類型";
    w_PromotionCodeDiscountTypePercent = "百分比折扣";
    w_PromotionCodeDiscountTypeAmount = "金額折扣";
    w_PromoCodeCreditAmount = "儲值金額";
    w_PromotionMinSpendAmount = "最低消費金額";
    w_PromotionMaxUses = "最大使用次數"; // zh-TW
    w_PromotionUsedCount = "已使用次數"; // zh-TW
    w_PromotionPerOrgLimit = "每組織可用次數"; // zh-TW

    // TranslationJob
    w_TranslationJobDescription = "監控進度並下載翻譯後的檔案。";
    w_TranslationJobCreateNew = "新增翻譯任務";
    w_TranslationJobAnalyzeStart = "分析開始";
    w_TranslationJobAnalyzing = "分析中...";
    w_TranslationJobConverting = "轉檔中...";
    w_TranslationJobConvertFailed = "轉檔失敗，請再試一次。";
    w_TranslationJobAnalyzeBadZip = "檔案格式錯誤或已損壞，請確認檔案內容。";
    w_TranslationJobAnalyzeNoTextTitle = "未偵測到文字內容";
    w_TranslationJobAnalyzeNoTextDesc = "這份檔案裡似乎沒有需要翻譯的文字";
    w_TranslationJobAnalyzeFailed = "分析失敗，請再試一次。";
    w_TranslationJobAnalyzeStepUpload = "上傳檔案與語言";
    w_TranslationJobFile = "檔案";
    w_TranslationJobSourceLang = "來源語言";
    w_TranslationJobTargetLang = "目標語言";
    w_TranslationJobTokens = "Token 數";
    w_TranslationJobWords = "字數";
    w_FileKindWord = "Word";
    w_FileKindExcel = "Excel";
    w_FileKindPowerPoint = "PowerPoint";
    w_TranslationJobPages = "頁數";
    w_TranslationJobBalanceLabel = "餘額:";
    w_TranslationJobTopup = "加值";
    w_TranslationJobTopupTitle = "加值";
    w_TranslationJobTopupTarget = "加值至：";
    w_TranslationJobTopupOnline = "線上付款";
    w_TranslationJobTopupRedeem = "兌換代碼";
    w_TranslationJobTopupSelectAmount = "選擇金額 (TWD)";
    w_TranslationJobTopupPopular = "熱門";
    w_TranslationJobTopupCustomAmount = "自訂金額...";
    w_TranslationJobTopupDiscount = "折扣碼";
    w_TranslationJobTopupDiscountPlaceholder = "例如 SAVE10";
    w_TranslationJobTopupApply = "套用";
    w_TranslationJobTopupSubtotal = "小計";
    w_TranslationJobTopupDiscountLabel = "折扣";
    w_TranslationJobTopupTotal = "應付金額";
    w_TranslationJobTopupCreditPoints = "預計獲得點數";
    w_TranslationJobTopupPay = "信用卡付款";
    w_TranslationJobTopupSecure = "由 ECPay 安全付款";
    w_TranslationJobTopupAgreeTerms = "我已閱讀並同意";
    w_TranslationJobTopupTerms = "服務條款與退款政策";
    w_TranslationJobTopupCardNumber = "卡號";
    w_TranslationJobTopupCardNumberPlaceholder = "1234 5678 9012 3456";
    w_TranslationJobTopupCardExpired = "到期日 (MMYY)";
    w_TranslationJobTopupCardExpiredPlaceholder = "MMYY";
    w_TranslationJobTopupCardCvc = "安全碼";
    w_TranslationJobTopupCardCvcPlaceholder = "123";
    w_TranslationJobTopupVoucher = "兌換碼";
    w_TranslationJobTopupVoucherPlaceholder = "例如 SPRING2026";
    w_TranslationJobTopupVoucherHint = "輸入你的優惠代碼以兌換點數";
    w_TranslationJobTopupRedeemButton = "兌換";
    w_TranslationJobTopupRedeemEmpty = "請輸入優惠代碼";
    w_TranslationJobTopupRedeemSuccess = "兌換成功，已加值 {0} 點數。";
    w_TranslationJobTopupRedeemFailed = "兌換失敗，請稍後再試。";
    w_TranslationJobTopupRedeemNotFound = "優惠代碼不存在";
    w_TranslationJobTopupRedeemDisabled = "優惠代碼已停用";
    w_TranslationJobTopupRedeemNotStarted = "優惠代碼尚未開始";
    w_TranslationJobTopupRedeemExpired = "優惠代碼已過期";
    w_TranslationJobTopupRedeemMaxUses = "優惠代碼已達使用上限";
    w_TranslationJobTopupRedeemNotCredit = "此優惠代碼無法兌換點數";
    w_TranslationJobTopupRedeemInvalid = "優惠代碼無效";
    w_TranslationJobTopupRedeemOrgLimit = "此優惠代碼已達組織使用上限";
    w_TranslationJobTopupRedeemOrgNotFound = "找不到此帳號的組織";
    w_TranslationJobTopupRedeemWalletNotFound = "找不到此組織的錢包";
    w_TranslationJobTopupPayuniNotConfigured = "付款服務尚未設定。";
    w_TranslationJobTopupAmountInvalid = "儲值金額無效。";
    w_TranslationJobTopupCardInvalid = "信用卡資訊無效。";
    w_TranslationJobTopupOrgNotFound = "找不到此帳號的組織。";
    w_TranslationJobTopupWalletNotFound = "找不到此組織的錢包。";
    w_TranslationJobTopupPayuniRequestFailed = "付款請求失敗。";
    w_TranslationJobTopupPayuniResponseInvalid = "付款回應無效。";
    w_TranslationJobTopupPayuniHashInvalid = "付款回應驗證失敗。";
    w_TranslationJobTopupPayuniIframeDomainMissing = "付款網域尚未設定。";
    w_TranslationJobTopupPayuniSdkUrlMissing = "付款 SDK 網址尚未設定。";
    w_TranslationJobTopupPayuniSdkTokenFailed = "付款初始化失敗。";
    w_TranslationJobTopupPayuniTokenMissing = "付款 Token 遺失。";
    w_TranslationJobTopupPayuniUnknown = "付款待確認，請稍後再試。";
    w_TranslationJobTopupPayuniUnapproved = "付款待審核。";
    w_TranslationJobTopupPayuniFailed = "付款失敗。";
    w_TranslationJobTopupPayuniTradeNotPaid = "付款未完成。";
    w_TranslationJobTopupPayuniSuccess = "付款成功，已更新錢包。";
    w_TranslationJobTopupPayuniInit = "正在載入付款元件...";
    w_TranslationJobOwnedOrganizations = "擁有的組織";
    w_TranslationJobMemberships = "關聯成員";
    w_TranslationJobTaskFile = "任務名稱 / 檔案";
    w_TranslationJobLanguages = "語言";
    w_TranslationJobStatusProgress = "狀態與進度";
    w_TranslationJobCost = "費用";
    w_TranslationJobActions = "操作";
    w_FailedJobDescription = "集中檢視翻譯失敗任務，下載原始檔案並查看錯誤訊息。";
    w_FailedJobUserOrg = "使用者 / 組織";
    w_FailedJobFile = "翻譯檔案";
    w_FailedJobError = "錯誤原因 / 內容";
    w_FailedJobFailedAt = "失敗時間";
    w_FailedJobActions = "操作";
    w_FailedJobDownloadSource = "下載原始檔案";
    w_FailedJobFilterAllTypes = "全部類型";
    w_FailedJobFilterCompleted = "翻譯完成";
    w_FailedJobFilterTimeout = "逾時";
    w_FailedJobFilterUnsupported = "不支援";
    w_FailedJobFilterResolved = "已處理";
    w_FailedJobFilterCritical = "待處理";
    w_CompanyName = "星錡股份有限公司";
    w_CompanyTaxId = "統一編號：55974998";
    w_TranslationJobDownload = "下載";
    w_ContactUs = "聯絡我們";
    w_TranslationJobStatusQueued = "排程中";
    w_TranslationJobStatusStarting = "啟動中";
    w_TranslationJobStatusProcessing = "翻譯中";
    w_TranslationJobStatusCompleted = "已完成";
    w_TranslationJobStatusFailed = "失敗";
    w_TranslationJobFailDetailTitle = "任務失敗詳情";
    w_TranslationJobFailFileName = "檔案名稱";
    w_TranslationJobFailReason = "錯誤原因";
    w_TranslationJobFailErrorMessage = "錯誤內容";
    w_TranslationJobFailSuggestion = "建議操作";
    w_TranslationJobFailReasonTimeoutTitle = "翻譯處理逾時";
    w_TranslationJobFailReasonTimeoutDetail =
        "翻譯過程花費的時間超出預期，請稍候再試一次。";
    w_TranslationJobFailReasonCriticalTitle = "無法翻譯此檔案";
    w_TranslationJobFailReasonCriticalDetail =
        "處理此檔案時發生了未知的錯誤，系統已自動提交錯誤報告給我們。很抱歉，若再次上傳相同的檔案仍會導致失敗。";
    w_TranslationJobFailReasonUnsupportedTitle = "不支援此檔案格式";
    w_TranslationJobFailReasonUnsupportedDetail =
        "系統目前尚未支援此檔案類型。請改用我們支援的格式，再次上傳原檔案將無法成功處理。";
    w_TranslationJobFailSuggestionRetryLine = "請稍候片刻再重新嘗試。";
    w_TranslationJobFailSuggestionStopLine =
        "由於目前無法排除此狀況，再次嘗試仍會出現相同的錯誤。";
    w_TranslationJobFailSuggestionFixFormatLine =
        "建議您將文件另存為標準的 Office 格式，或移除特殊的排版後再試一次。";
    w_TranslationJobResolve = "處理";
    w_TranslationJobResolveTitle = "檢修報告";
    w_TranslationJobResolveMessage = "檢修內容";
    w_TranslationJobResolvePlaceholder = "請輸入檢修內容";
    w_TranslationJobResolveSubmit = "提交";
    "建議您將文件另存為標準的 Office 格式，或移除特殊的排版後再試一次。";
    w_TranslationJobUploadTitle = "拖曳檔案至此";
    w_TranslationJobUploadHint =
        "支援格式：.doc, .docx, .xls, .xlsx, .ppt, .pptx（最大 {0}）";
    w_TranslationJobBrowseFiles = "瀏覽檔案";
    w_TranslationJobFileSelected = "已選取檔案";
    w_TranslationJobChangeFile = "更換檔案";
    w_TranslationJobStepUpload = "上傳與設定";
    w_TranslationJobStepEstimate = "估算與確認";
    w_TranslationJobDetected = "偵測語言";
    w_TranslationJobSize = "檔案大小";
    w_TranslationJobReady = "就緒";
    w_TranslationJobEstimatedWords = "預估字數";
    w_TranslationJobEstimatedCost = "預估點數";
    w_TranslationJobWordsUnit = "字";
    w_PointUnit = "點";
    w_TranslationJobEstimateNotice = "分析為估算，實際費用可能因最終 token 數稍有差異。";
    w_TranslationJobConfirmNotice = "已計算 token 數量，確認後即可建立翻譯任務。";
    w_TranslationJobConfirmInsufficient = "餘額不足，請先儲值。";
    w_TranslationJobTopupNow = "立即儲值";
    w_TranslationJobConfirmWalletNotFound = "找不到此組織的錢包。";
    w_TranslationJobWalletBalance = "錢包點數";
    w_TranslationJobBalanceAfter = "交易後點數";
    w_TranslationJobNextUpload = "下一步：上傳下一個檔案";
    w_TranslationJobConfirmTranslate = "確認並開始翻譯";
    w_TranslationJobCreating = "建立中...";
    w_TranslationJobConfirmFailed = "建立翻譯任務失敗。";
    w_LangAuto = "自動偵測";
    w_LangEnglish = "英文";
    w_LangJapanese = "日文";
    w_LangTraditionalChinese = "繁體中文";
    w_LangSimplifiedChinese = "簡體中文";
    w_LangFrench = "法文";
    w_LangThai = "泰文";
    w_LangIndonesian = "印尼文";
    w_LangVietnamese = "越南文";

    /// Others
    w_OK = "確定";
    w_User = "使用者";
    w_BelongToInstance = "屬於 {0}";
    w_Relations = "關聯";
    w_Filter = "篩選:";
    w_Unlimited = "不限";
    w_Manage = "管理";
    w_Status = "狀態";
    w_StatusActive = "啟用中";
    w_StatusInactive = "未啟用";
    w_StatusDisabled = "已停用";
    w_StatusExhausted = "用盡";
    w_JoinedDate = "加入日期";
    w_CreatedAt = "建立日期";
    w_SaveChanges = "儲存變更";
    w_LeaveOrganization = "離開";
    w_ConfirmLeave = "確認離開";
    w_ConfirmUnlink = "確認解除連結";

    // Title
    w_TitleSub1 = "AI 翻譯新標準，暢飲效率與成功";
    w_TitleSub2 = "Quality 品質";
    w_TitleSub3 = "專業文件訓練，提供高於市場水準的翻譯準確性。";
    w_TitleSub4 = "Uncompromised Format 格式還原";
    w_TitleSub5 =
        "專注於版面 fidelity，確保簡報設計、表格結構與文件排版在翻譯後維持原樣，無需重工。";
    w_TitleSub6 = "Abundant File Support 檔案類型";
    w_TitleSub7 =
        "一站式處理您所有的翻譯需求，全面支援 Word、Excel、PowerPoint 等主流 Office 文件格式。";
    w_TitleSub8 = "Fantastic Efficiency 效率提升";
    w_TitleSub9 = "省下 70% 格式調整時間，釋放您寶貴的時間與生產力。";
    w_TitleSub10 = "登入您的帳號";
    w_TitleSub11 = "選擇任一方式以繼續";
    w_TitleSub12 = "使用 Google 帳號登入";
    w_TitleSub13 = "本地登入";
    w_TitleSub14 = "企業登入";
    w_TitleSub15 = "保持登入";
    w_TitleSub16 = "帳號";
    w_TitleSub17 = "LDAP 帳號";
    w_TitleSub18 = "忘記密碼?";
    w_LoginUsernamePlaceholder = "Email 或帳號";
    w_LoginPasswordPlaceholder = "密碼";
    w_LoginLdapPlaceholder = "LDAP 帳號";
    w_LoginLdapPasswordPlaceholder = "LDAP 密碼";

    /// Error handler
    w_DataDuplicate = "資料重複";
    e_InvalidCurrentPassword = "當前的密碼錯誤，無法更新使用者密碼。";
    e_UNIQUE_CONSTRAINT = "資料重複，請檢查後再試。";
    e_UNIQUE_CONSTRAINT_FIELD = "<b class='text-info'>{0}</b> 已存在，請更換後再試。";
}
